<template>
  <v-card 
      :class="[type === 'workout' ? 'my-4 mx-1' : 'drag-el my-2 mx-4']"
      :color="color"
      @click="toggle"
      :ripple="type === 'default'"
      :width="type === 'default' ? '200px' : 'unset'"
      @dragstart="startDrag($event)">

      <v-img v-if="type !== 'workout'"
        height="150"
        class="mx-4 mt-4"
        :src="icon"
        contain
      ></v-img>

      <v-card-title :class="[!activeSwitch ? 'grey--text' : '']">
        <v-row>
          <v-col v-if="type === 'workout'" cols="2">
            <v-img
              width="50"
              :src="icon"
              contain
            ></v-img>
          </v-col>

          <div>
            {{ name }}
            </div>
          
            <v-spacer></v-spacer>

            <div class="mr-4" v-if="type === 'workout'">
              <v-switch class="mt-0"
                v-model="activeSwitch"
                :label="`${activeSwitch ? '' : ''}`"
                @click="deactivate"
              ></v-switch>
            </div>

            <div class="mr-4" v-if="type === 'workout'">
              <v-btn icon 
                @click="remove">
                <v-icon size="23">mdi-trash-can</v-icon>
              </v-btn>
            </div>

        </v-row>
      </v-card-title>

      <v-card-text>
        {{ description }}
      </v-card-text>

      <v-expansion-panels v-if="type === 'workout'" flat>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Settings
          </v-expansion-panel-header>
          <v-expansion-panel-content>

            <v-card-actions class="pb-0">
                <v-subheader>{{ rounds }} Rounds</v-subheader>
            </v-card-actions>

            <v-card-actions class="pt-0">
              <v-slider
                v-model="rounds"
                track-color="grey"
                always-dirty
                min="3"
                max="10"
                thumb-label
              >
                <template v-slot:prepend>
                  <v-icon
                    @click="rounds--"
                  >
                    mdi-minus
                  </v-icon>
                </template>

                <template v-slot:append>
                  <v-icon
                    @click="rounds++"
                  >
                    mdi-plus
                  </v-icon>
                </template>
              </v-slider>
            </v-card-actions>

            <v-card-actions class="pb-0">
                <v-subheader>{{ iterations }} Iterations</v-subheader>
            </v-card-actions>

            <v-card-actions class="pt-0">
              <v-slider
                v-model="iterations"
                track-color="grey"
                always-dirty
                min="5"
                max="50"
                thumb-label
              >
                <template v-slot:prepend>
                  <v-icon
                    @click="iterations--"
                  >
                    mdi-minus
                  </v-icon>
                </template>

                <template v-slot:append>
                  <v-icon
                    @click="iterations++"
                  >
                    mdi-plus
                  </v-icon>
                </template>
              </v-slider>
            </v-card-actions>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card-actions v-if="type === 'default'">
        <v-spacer></v-spacer>

        <v-btn
          color="orange lighten-2"
          text
          @click="add"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
  export default {
    name: 'Task',

    props: {
      id: Number,
      name: String,
      icon: String,
      level: Number,
      parts: Array,
      description: String,
      duration: Number,
      type: {
          default: function () {
              return 'default'
          },
          type: String
      },
      active: Boolean,
      toggle: {
          default: function () {
              return () => {}
          },
          type: Function
      },
    },

    data: () => ({
      activeSwitch: true,
      rounds: 3,
      iterations: 15,
      color: undefined,
    }),    

    created() {
      this.color = this.active ? undefined : 'white'
      console.log(this.icon)
    },

    methods: {
      add: function() {
         this.$emit('add-task')
      },

      remove() {
         this.$emit('remove-task')
      },

      deactivate() {
        this.$emit('deactivate-task', this.activeSwitch)
      },

      startDrag(evt) {
        if (this.type === 'default') {
          this.$emit('start-drag', evt)
        }
      },
    },

    watch: {
      active: function(val) {
        this.color = val ? 'white' : 'white'
      },
    },
  }
</script>

<style scoped>
  .drag-el {
    cursor: pointer;
  }
</style>